import { memo } from 'react';

import {
  FileStatusButton,
  FileStatusIconProgressing,
  FileStatusSubtitle,
  FileStatusTitle,
} from '@air/feature-file-status/ui';
import { ChevronDown } from '@air/next-icons';

import { EllipsisInMiddle } from '~/components/EllipsisInMiddle';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { type GetInProgressMetadata, type LibraryRestorationTask } from '~/store/tasks/types';

export type RestoreLibraryPanelInProgressPanelItemProps = {
  metadata: Pick<GetInProgressMetadata<LibraryRestorationTask>, 'title'>;
  onCancel: () => void;
};

export const RestoreLibraryPanelInProgressPanelItem = memo(
  ({ onCancel, metadata: { title } }: RestoreLibraryPanelInProgressPanelItemProps) => {
    return (
      <PaneItemTW
        avatar={<FileStatusIconProgressing />}
        title={<FileStatusTitle>Recovering library</FileStatusTitle>}
        subtitle={
          <FileStatusSubtitle className="flex text-nowrap">
            <span className="flex-none pr-1">Recovering library: </span>
            <EllipsisInMiddle className="font-bold" text={title || ''} />
          </FileStatusSubtitle>
        }
        buttons={
          <FileStatusButton label="Hide" onClick={onCancel}>
            <ChevronDown className="size-4" />
          </FileStatusButton>
        }
      />
    );
  },
);

RestoreLibraryPanelInProgressPanelItem.displayName = 'RestoreLibraryPanelInProgressPanelItem';
